/**
 * @generated SignedSource<<86848242955be7c31efba6b32ecfc5df>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useItemMediaItems_item$data = {
  readonly isMultiSku: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"useShowVimeoVideo_item">;
  readonly " $fragmentType": "useItemMediaItems_item";
};
export type useItemMediaItems_item$key = {
  readonly " $data"?: useItemMediaItems_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useItemMediaItems_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowVimeoVideo_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "aed42c2f360812658a95790bbac8b481";

export default node;
